var bmConfig = {};
bmConfig.framework = {};
bmConfig.framework.rootFolder = '/';

//var CKEDITOR_BASEPATH = '/blueprint/vendors/ckeditor/latest/';
var CKEDITOR_BASEPATH = '/blueprint/vendors/ckeditor/latest/';
